module.exports = __webpack_public_path__ + "collab.svg?ef11f07c41028e41d1593d826c47da34";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/collab.svg
// module id = 118
// module chunks = 0